import {
    LIST_PERSON_TYPES,
    LIST_PERSON_TYPES_SUCCESS,
    LIST_PERSON_TYPES_ERROR,
    ADD_PERSON_TYPES,
    SAVE_PERSON_TYPES,
    SAVE_PERSON_TYPES_SUCCESS,
    SAVE_PERSON_TYPES_ERROR,
    EDIT_PERSON_TYPES,
    UPDATE_PERSON_TYPES,
    UPDATE_PERSON_TYPES_SUCCESS,
    UPDATE_PERSON_TYPES_ERROR,
    DELETE_PERSON_TYPES,
    DELETE_PERSON_TYPES_SUCCESS,
    DELETE_PERSON_TYPES_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    personTypes: null,
    error: null,
    loading: false,
    personTypeSelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_PERSON_TYPES:
            return {
                ...state,
                loading: true
            }
        case LIST_PERSON_TYPES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_PERSON_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                personTypes: action.payload
            }
        case SAVE_PERSON_TYPES:
        case DELETE_PERSON_TYPES:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_PERSON_TYPES:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_PERSON_TYPES_ERROR:
        case UPDATE_PERSON_TYPES_ERROR:
        case DELETE_PERSON_TYPES_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_PERSON_TYPES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                personTypes: [...state.personTypes, action.payload]
            }
        case ADD_PERSON_TYPES:
            return {
                ...state,
                personTypeSelected: null,
                isEdit: false
            }
        case EDIT_PERSON_TYPES:
            return {
                ...state,
                personTypeSelected: action.payload,
                isEdit: true
            }
        case UPDATE_PERSON_TYPES_SUCCESS:
        case DELETE_PERSON_TYPES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                personTypes: state.personTypes.map(personType => 
                    personType.id === action.payload.id ? personType = action.payload : personType
                ),
                personTypeSelected: null
            }
        // case DELETE_PERSON_TYPES_SUCCESS:
        //     return {
        //         ...state,
        //         loadingSave: false,
        //         errorSave: null,
        //         personTypes: state.personTypes.filter( personType => personType.id !== action.payload)
        //     }
        default:
            return state;
    }
}